import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PardotPicklistValueList } from '@periscopes/general/pardot-picklist-values';
import { PeriscopePardotFieldMetadata } from '@sonar-software/sonar-ts-types';
import { useApiResource } from '@hooks';
import { When } from 'react-if';

import { MetadataContainer, MetadataEntry } from '@periscopes/general/metadata';
import React, { useMemo } from 'react';

export interface PardotFieldMetadataTabProps {
	index: number;
	picklistValueCount: number;
	sonarObjectId: number;
}

export const PardotFieldMetadataTab: React.FC<PardotFieldMetadataTabProps> = ({
	index,
	picklistValueCount,
	sonarObjectId
}) => {
	const pardotFieldMetadataUri = `v3/pardot/fields/${sonarObjectId}/field-metadata`;
	const picklistPardotFieldUri = `v3/pardot/fields/${sonarObjectId}/picklist-field-metadata`;

	const { loading, resource } = useApiResource<PeriscopePardotFieldMetadata>(pardotFieldMetadataUri);

	const { syncBehavior } = resource ?? {};

	const metadataEntries = useMemo(() => {
		const entries: MetadataEntry[] = [
			{
				label: COPY_SPECIFIC.SYNC_BEHAVIOR,
				type: 'string',
				value: syncBehavior
			}
		];

		return entries;
	}, [ syncBehavior ]);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	return (
		<>
			<MetadataContainer
				entries={ metadataEntries }
				title={ COPY_SPECIFIC.FIELD_INFORMATION } />
			<When condition={ picklistValueCount > 0 }>
				<PardotPicklistValueList
					parentIndex={ index }
					uri={ picklistPardotFieldUri } />
			</When>
		</>
	);
};
